import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik"
import * as Yup from "yup"

// Components
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
  CSpinner
} from '@coreui/react-pro'

// icons
import CIcon from '@coreui/icons-react'
import { cilLockLocked } from '@coreui/icons'

// helpers
import Axios from '../../../helpers/axios'
import useToastMessage from 'src/helpers/toast-message'

const ResetPassword = () => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useToastMessage();
  const { userResetPasswordToken } = useParams();

  const [isLoading, setIsLoading] = useState(false)
  const [passwordInputType, setPasswordInputType] = useState("password");

  const formik = useFormik({
    initialValues: {
      password: '',
      reTypePassword: ''
    },
    validationSchema: Yup.object().shape({
      password: Yup.string().required("Please enter your new password."),
      reTypePassword: Yup.string().oneOf([Yup.ref('password'), null], 'Re-type password must match').required("Please re-type your new password.")
    }),
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting }) => {
      handleSubmit(values)
      setSubmitting(false)
    },
  });

  const handleInputValue = (values) => {
    const payload = {}

    payload.password = values.password
    payload.token = userResetPasswordToken

    return payload
  }

  const handleResetPassword = (payload) => {
    setIsLoading(true)
    Axios({
      method: "post",
      url: '/api/sso/v1/users/change/password',
      data: payload
    })
      .then(({ data }) => {
        if (data) {
          const { success, value } = data || {};
          if (success) {
            showSuccess('You have successfully change password, please Log in to your account using the new password.')
            Axios({
              method: "post",
              url: `/api/whatsapp/v1/email/send/user-change-password`,
              data: {
                user: {
                  id: value?.id,
                }
              }
            })
              .then(() => {
                // success sending email verify user
              })
              .catch((err) => {
                console.error(err)
              })

            setTimeout(() => {
              navigate('/login')
            }, 2500)
          }
        }
      })
      .catch((err) => {
        console.error(err);
        if (err && err.response && err.response.data) {
          const { response: { data: { message } = {} } = {} } = err || {};
          if (message) {
            if (message === 'user-not-found') {
              showError('Your account is not found')
            }
          }
        }
      })
      .finally(() => setIsLoading(false))
  }

  const handleSubmit = (values) => {
    const inputPayload = handleInputValue(values)
    handleResetPassword(inputPayload)
  }

  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={6}>
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <CForm>
                    <h1>Reset Password</h1>
                    <p className="text-medium-emphasis">Reset your password</p>
                    <CInputGroup className="mb-3">
                      <CInputGroupText>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <CFormInput
                        type={passwordInputType}
                        id='password'
                        name='password'
                        placeholder={"Fill in password"}
                        value={formik.values.email}
                        onChange={(e) => formik.handleChange(e)}
                        invalid={formik.errors.password}
                        feedbackInvalid={formik.errors.password}
                        autoComplete='off'
                      />
                    </CInputGroup>
                    <CInputGroup className="mb-4">
                      <CInputGroupText>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <CFormInput
                        type={passwordInputType}
                        placeholder={"Re-type password"}
                        id='reTypePassword'
                        name='reTypePassword'
                        value={formik.values.reTypePassword}
                        onChange={(e) => formik.handleChange(e)}
                        invalid={formik.errors.reTypePassword}
                        feedbackInvalid={formik.errors.reTypePassword}
                        autoComplete='off'
                      />
                    </CInputGroup>
                    <CRow>
                      <CCol xs={6}>
                        <CButton
                          color="dark"
                          className="px-4"
                          onClick={() => formik.handleSubmit()}
                        >
                          {isLoading && (
                            <CSpinner
                              className='me-2'
                              component="span"
                              color="light"
                              size="sm"
                              aria-hidden="true"
                            />
                          )}
                          Submit
                        </CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
};

export default ResetPassword;
